export const PROJECTS = [
  {
    id: '1',
    title: 'Link-Campus',
    description:
      'Link-Campus is an social media website using MEAN stack technology for students and teachers to share notes and college updates, improving communication and collaboration within the college community.',
    image: {
      src: 'https://cdn.dribbble.com/users/925704/screenshots/6513438/scrolling.gif',
      placeholderSrc:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://incredible-dragon-cf2ed5.netlify.app/',
      repo: 'https://github.com/nirajj-pal/SocialMedia_Project',

    },
    technologies: [
      '#React.js',
      '#Node.js',
      '#JavaScript',
      '#MongoDB',
      '#express.js',
    ],
  },
  {
    id: '2',
    title: 'Data Visualization of crypto market',
    description:
      'Developed a live auto-updating DashBoard of the Crypto market Data used is Dynamic , coming directly from coingeko API The data is visualized in graphical form using ApexCharts.js',
    image: {
      src: 'https://www.sovereignconsult.com/wp-content/uploads/2019/07/blockchain-development.gif',
      placeholderSrc:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://nirajj-react-dashboard.netlify.app/',
      repo: 'https://github.com/nirajj-pal/Data-Visualization-of-crypto-market',

    },
    technologies: [
      '# React.js',
      '#Node.js',
      '#JavaScript',
      '#ApexCharts',
      '#CoinGecko AP',
    ],
  },
  {
    id: '3',
    title: 'Real-time Chat Application',
    description:
      "Created a realTime Scalable chat Application using Node.js and sockets.io. Where multiple users can chat together and messages get updated without refreshing the page. Every user in the chat get notified whenever any user join or left the chat.",
    image: {
      src: 'https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExMTI1NTM4MzYwNzQ1MjVlYjBhMWRkODNhYTQyYzE2ZTIzZjZjY2MyNiZjdD1n/26FPJGjhefSJuaRhu/giphy.gif',
      placeholderSrc:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://github.com/nirajj-pal/Real-time-Chat-Application',
      // repo: 'https://github.com/vsnaichuk/fashion-app',
    },
    technologies: [
      '#Node.js',
      '#sockets.io',
      '#WebSockets',
      '#JavaScript',
    ],
  },
  {
    id: '4',
    title: 'FilmPire: Revolutionizing Movie Discovery',
    description:
      'A robust movie application that allows users to explore a vast selection of movies across various categories and genres.',
    image: {
      src: 'https://mir-s3-cdn-cf.behance.net/project_modules/hd/451ab567865067.5b5f2650074f0.gif',
      placeholderSrc:
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://cute-madeleine-c642ea.netlify.app/',
      repo: 'https://github.com/nirajj-pal/Filmpire-Revolutionizing-Movie-Discovery',
    },
    technologies: [
      '#react',
      '#redux',
      '#JavaScript',
      '#Alan Ai',
      '#The Movie DB API',
      '#react-window',
      '#restapi',
    ],
  },
  // {
  //   id: '5',
  //   title: 'Places App',
  //   description:
  //     'A MERN app to let users share their experience of places along with Details. It is user friendly and can be useful to many others.',
  //   image: {
  //     src: 'https://res.cloudinary.com/dx6tl6aa2/image/upload/v1628348070/portfolio/projects/mern-places/mern-places-lg_xf6zom.jpg',
  //     placeholderSrc:
  //       'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
  //   },
  //   links: {
  //     site: 'https://yourplaces-sv.netlify.app/',
  //     repo: 'https://github.com/vsnaichuk/MERN-places',
  //   },
  //   technologies: [
  //     '#react',
  //     '#nodejs',
  //     '#express',
  //     '#mongodb',
  //     '#react-query',
  //     '#react-transition-group',
  //     '#mongoose',
  //     '#jwt',
  //     '#aws',
  //   ],
  // },
  // {
  //   id: '6',
  //   title: 'eCommerce Mobile App',
  //   description:
  //     'A Mobile eCommerce application built with React Native that includes cart functionality, push notifications, user authentication and user orders',
  //   image: {
  //     src: 'https://res.cloudinary.com/dx6tl6aa2/image/upload/v1628348073/portfolio/projects/rn-shop/rn-shop-lg_fofglf.jpg',
  //     placeholderSrc:
  //       'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
  //   },
  //   links: {
  //     site: 'https://expo.dev/@v_snaichuk/online-shop-app',
  //     repo: 'https://github.com/vsnaichuk/RN-shop',
  //   },
  //   technologies: [
  //     '#react-native',
  //     'expo',
  //     '#redux',
  //     '#redux-toolkit',
  //     '#react-navigation',
  //     '#nodejs',
  //     '#express',
  //     '#mongodb',
  //   ],
  // },
  // {
  //   id: '7',
  //   title: 'Places Mobile App',
  //   description:
  //     'A Mobile application for sharing places that people visit from all over the world. Uses React Native, TypeScript, MobX and Native Device Features',
  //   image: {
  //     src: 'https://res.cloudinary.com/dx6tl6aa2/image/upload/v1628348073/portfolio/projects/rn-places/rn-places-lg_ljyikm.jpg',
  //     placeholderSrc:
  //       'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
  //   },
  //   links: {
  //     site: 'https://expo.dev/@v_snaichuk/rn-places',
  //     repo: 'https://github.com/vsnaichuk/RN-places',
  //   },
  //   technologies: [
  //     '#react-native',
  //     '#typescript',
  //     '#expo',
  //     '#mobx',
  //     '#sqlite',
  //     '#react-native-maps',
  //     '#expo-location',
  //   ],
  // },
  // {
  //   id: '8',
  //   title: 'Shopping Cart',
  //   description:
  //     'Simple eCommerce cart application built with React and TypeScript. Uses SWR hook to fetch the data from the API and Styled Components',
  //   image: {
  //     src: 'https://res.cloudinary.com/dx6tl6aa2/image/upload/v1628348073/portfolio/projects/react-shop-cart/rn-shop-cart-lg_w3qxn6.jpg',
  //     placeholderSrc:
  //       'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
  //   },
  //   links: {
  //     site: 'https://shopping-cart-sv.netlify.app/',
  //     repo: 'https://github.com/vsnaichuk/React-ShoppingCart',
  //   },
  //   technologies: [
  //     '#react',
  //     '#typescript',
  //     '#material-ui',
  //     '#styled-components',
  //     '#swr',
  //     '#fakestoreapi',
  //   ],
  // },
];
